import type { AlertTemplateProps } from './index';
import { translate } from '../../i18n';

export default function AlertTemplate({
  classes,
  title,
  message,
  icon,
  actions,
  actionsUnder,
  closable,
  onClose,
}: AlertTemplateProps) @{
  <div role="alert" class={classes} data-dls-component="alert">
    <div class="alert-container">
      <div class="alert-content">
        <div class="alert-header">
          @if (icon !== undefined) {
            <div class="alert-icon">{icon}</div>
          }
          @if (title() !== undefined) {
            <div class="alert-title">{title()}</div>
          } @else {
            <div class="alert-description">{message()}</div>
          }
        </div>
        @if (title() !== undefined) {
          <div class="alert-description alert-description-with-title">{message()}</div>
        }
        @if (actionsUnder) {
          <div class="alert-actions-under">{actions}</div>
        }
      </div>
      @if (!actionsUnder) {
        <div class="alert-actions-right">{actions}</div>
      }
    </div>
    @if (closable) {
      <button type="button" aria-label="Close" class="btn ghost alert-close-button" onClick={onClose}>
        <span class="sr-only">{translate('common.dismiss')}</span>
        <svg class="size-5 text-[rgb(var(--color-text-emphasis))]" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
          <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
        </svg>
      </button>
    }
  </div>
}
